/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SignupStep } from './';
import {
    SignupStepFromJSON,
    SignupStepFromJSONTyped,
    SignupStepToJSON,
} from './';

/**
 * 
 * @export
 * @interface StepCompanyDetails
 */
export interface StepCompanyDetails extends SignupStep {
    /**
     * The ID of the company. Useful to enforce the user identity.
     * @type {string}
     * @memberof StepCompanyDetails
     */
    companyId: string;
    /**
     * The company name we already have in case the user is a new member of an existing company
     * 
     * @type {string}
     * @memberof StepCompanyDetails
     */
    companyName?: string;
    /**
     * The website URL of the company
     * @type {string}
     * @memberof StepCompanyDetails
     */
    companyWebsiteUrl?: string;
    /**
     * The company size we already have in case the user is a new member of an existing company
     * 
     * @type {string}
     * @memberof StepCompanyDetails
     */
    companySize?: string;
    /**
     * The company industry we already have in case the user is a new member of an existing company
     * 
     * @type {string}
     * @memberof StepCompanyDetails
     */
    companyIndustry?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StepCompanyDetails
     */
    edrMatches: boolean;
    /**
     * 
     * @type {string}
     * @memberof StepCompanyDetails
     */
    nameOfCompanyThatUserWantedToJoinButIsArchived?: string;
}

/**
 * Check if a given object implements the StepCompanyDetails interface.
 */
export function instanceOfStepCompanyDetails(value: object): value is StepCompanyDetails {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('edrMatches' in value) || value['edrMatches'] === undefined) return false;
    return true;
}

export function StepCompanyDetailsFromJSON(json: any): StepCompanyDetails {
    return StepCompanyDetailsFromJSONTyped(json, false);
}

export function StepCompanyDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StepCompanyDetails {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepFromJSONTyped(json, ignoreDiscriminator),
        'companyId': json['companyId'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'companyWebsiteUrl': json['companyWebsiteUrl'] == null ? undefined : json['companyWebsiteUrl'],
        'companySize': json['companySize'] == null ? undefined : json['companySize'],
        'companyIndustry': json['companyIndustry'] == null ? undefined : json['companyIndustry'],
        'edrMatches': json['edrMatches'],
        'nameOfCompanyThatUserWantedToJoinButIsArchived': json['nameOfCompanyThatUserWantedToJoinButIsArchived'] == null ? undefined : json['nameOfCompanyThatUserWantedToJoinButIsArchived'],
    };
}

export function StepCompanyDetailsToJSON(value?: StepCompanyDetails | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepToJSON(value, true),
        'companyId': value['companyId'],
        'companyName': value['companyName'],
        'companyWebsiteUrl': value['companyWebsiteUrl'],
        'companySize': value['companySize'],
        'companyIndustry': value['companyIndustry'],
        'edrMatches': value['edrMatches'],
        'nameOfCompanyThatUserWantedToJoinButIsArchived': value['nameOfCompanyThatUserWantedToJoinButIsArchived'],
    };
}

